export const LOADING_REDUCER = 'LoadingReducer';
